import { FeatureFlags } from '@scaleup/models';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { isNil } from 'lodash';
import { useFeatureFlagContext } from './context';

export const useLDFeatureFlag = <T>(flag: string, defaultValue: T): T => {
  const flags = useFlags();

  const _flags = { ...flags };
  const value = _flags[flag];

  // console.log(JSON.stringify(_flags, null, '  '));

  if (isNil(value)) {
    return defaultValue;
  }

  return value;
};

export const useFeatureFlag = <T>(
  flag: keyof FeatureFlags,
  defaultValue: T
): T => {
  const { featureFlags } = useFeatureFlagContext();
  if (!featureFlags) {
    return defaultValue;
  }

  const val = featureFlags[flag];
  if (isNil(val)) {
    return defaultValue;
  }

  return val as T;
};

export const LDFeatureFlags = {
  SUPPLIER_REQUEST_SAVE_AS_DRAFT: 'supplierRequestSaveAsDraft',
  ENTERPRISE_DASHBOARD_SUPPLIER_ACTIVITY: 'enterpriseDashboardSupplierActivity',
  ENTERPRISE_DASHBOARD_SUPPLIER_SPOTLIGHT:
    'enterpriseDashboardSupplierSpotlight',
  SUPPLIER_PROFILE_CAPABILITIES_AND_OFFERINGS_FEATURE_FLAG:
    'supplierProfileCapabilitiesOfferings',
  SUPPLIER_PROFILE_ACTIVITY_FEATURE_FLAG: 'supplierProfileActivityTab',
  SUPPLIER_PROFILE_PERFORMANCE_FEATURE_FLAG: 'supplierProfilePerformanceTab',
  SUPPLIER_PROFILE_ENDORSEMENTS_FEATURE_FLAG: 'supplierProfileEndorsementsTab',
  SUPPLIER_PROFILE_DOCUMENTS_FEATURE_FLAG: 'supplierProfileDocumentsTab',
  SAAS_TERMS_AND_CONDITIONS_ENABLED: 'saasTermsAndConditionsEnabled',

  // sourcing ally
  SA_SUPPLIER_PROFILE_DOCUMENTS_TAB_ENABLED:
    'saSupplierProfileDocumentsTabEnabled',
  SA_SUPPLIER_PROFILE_ACTIVITY_TAB_ENABLED:
    'saSupplierProfileActivtyTabEnabled',
  SA_SUPPLIER_PROFILE_PERFORMANCE_TAB_ENABLED:
    'saSupplierProfilePerformanceTabEnabled',
  SA_SUPPLIER_PROFILE_ENDORSEMENT_TAB_ENABLED:
    'saSupplierProfileEndorsementTabEnabled',
  SA_SUPPLIER_PROFILE_CAPABILITIES_TAB_ENABLED:
    'saSupplierProfileCapabilitiesTabEnabled',
  SA_SOURCING_REQUEST_FEEDBACK_ENABLED: 'saSourcingRequestFeedbackEnabled',
};
